import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0A0E27] border-t border-[#1E293B] py-12" data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6" data-id="element-109">
          <div className="text-[#94A3B8] text-sm" data-id="element-110">
            © {currentYear} CRM Kraft. All rights reserved.
          </div>
          <div className="flex gap-6 text-sm text-[#94A3B8]" data-id="element-111">
            <Link to="/impressum" className="hover:text-white transition-colors" data-id="element-112">
              Legal Notice
            </Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-id="element-113">
              Privacy Policy
            </Link>
            <a href="https://crm-kraft.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors flex items-center gap-1" data-id="element-114">
              CRM Kraft
              <ExternalLink className="w-3 h-3" data-id="element-115" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}